module.exports = __webpack_public_path__ + "img/vehicles.8f94494d.png";